import { Link } from "react-router-dom";
import { ScanLine } from "lucide-react";
import { Empty, Page } from "@/components/kit";
import Scan from "@/pages/Scan";
import { getGuest, guestUsed } from "@/lib/guest";

export const GuestHeader = () => (
  <header className="sticky top-0 z-20 bg-white/90 backdrop-blur border-b border-[#E2E8F0]">
    <div className="max-w-7xl mx-auto px-5 lg:px-10 h-16 flex items-center justify-between">
      <Link to="/login" className="flex items-center gap-2" data-testid="guest-logo"><img src="/logo.png" alt="TOTO" className="w-9 h-9 rounded-xl" /><span className="text-[20px] font-extrabold">TOTO</span></Link>
      <div className="flex items-center gap-2">
        <Link to="/login" className="t-link text-[14px] px-2" data-testid="guest-header-login">Log in</Link>
        <Link to="/register" className="t-btn t-btn-primary h-10 px-4 text-[14px]" data-testid="guest-header-register">Sign up free</Link>
      </div>
    </div>
  </header>
);

export default function GuestScan() {
  const used = guestUsed();
  return (
    <div className="min-h-screen bg-white">
      <GuestHeader />
      {used ? (
        <Page className="pt-10">
          <Empty icon={ScanLine} title="You've used your free guest scan" testid="guest-used"
            text="Create a free account to get 10 free scans and save your contacts."
            action={<div className="flex flex-col sm:flex-row gap-2 justify-center">
              {getGuest() && <Link to="/try/review" className="t-btn t-btn-outline" data-testid="guest-used-review">View scanned contact</Link>}
              <Link to="/register" className="t-btn t-btn-primary" data-testid="guest-used-register">Create free account</Link>
            </div>} />
        </Page>
      ) : <Scan guest />}
    </div>
  );
}
